import { http } from "../../utils/config";

const historyAPI = {
    
  getHistories: (params = {}) => {
    const {
      page = 1,
      per_page = 15,
      search = '',
      type = '',
      start_date = '',
      end_date = '',
      sort_by = 'created_at',
      sort_order = 'desc'
    } = params;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      per_page: per_page.toString(),
      sort_by,
      sort_order,
      ...(search && { search }),
      ...(type && { type }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date })
    });

    return http.get(`/api/v1/datamanagement/import/histories?${queryParams}`);
  },
};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
    return async (...args) => {
        try {
            const response = await apiFunction(...args);
            return response.data;
        } catch (error) {
            console.error("API Error:", error);

            if (error.response) {
                const { status, data } = error.response;
                switch (status) {
                    case 400:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 401:
                        throw new Error("Bạn cần đăng nhập để thực hiện thao tác này");
                    case 403:
                        throw new Error("Bạn không có quyền thực hiện thao tác này");
                    case 404:
                        throw new Error("Không tìm thấy thông tin");
                    case 422:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 500:
                        throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
                    default:
                        throw new Error(data.message || "Đã có lỗi xảy ra");
                }
            } else if (error.request) {
                throw new Error("Không thể kết nối đến server");
            } else {
                throw new Error(error.message || "Đã có lỗi xảy ra");
            }
        }
    };
};

// Wrapped API with error handling
export const historyAPIWithErrorHandling = {
    getHistories: withErrorHandling(historyAPI.getHistories),
};

export default historyAPI;
